import { render } from "./PendingApprovalFire.vue?vue&type=template&id=42c1bc04"
import script from "./PendingApprovalFire.vue?vue&type=script&lang=js"
export * from "./PendingApprovalFire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__